/** Constantes de tempo reutilizadas em prefetch, debounce e cache de sessão. */
export const N_MS_POR_DIA = 24 * 60 * 60 * 1000
export const N_MS_POR_MINUTO = 60 * 1000

export const N_DEBOUNCE_BUSCA_MS = 400
export const N_POLL_INTERVAL_MS = 400

export const N_CACHE_CONVERSAS_MS = 60 * 1000
export const N_CACHE_CONVERSAS_PRONTAS_MS = 2 * N_MS_POR_MINUTO
export const N_INTERVALO_PREFETCH_MS = 60 * 1000
export const N_STALE_METADADOS_MS = 5 * N_MS_POR_MINUTO
export const N_STALE_FLUXO_COLUNA_MS = 30 * 1000

export const N_ALTURA_ITEM_TICKET = 105
export const N_ALTURA_LISTA_FALLBACK = 400
export const N_MINIMO_ITENS_VIRTUAL = 20

export const N_LIMITE_DIAS_POR_HORA = 1
export const N_LIMITE_DIAS_POR_DIA = 16
export const N_LIMITE_DIAS_POR_SEMANA = 62

export const N_TIMEOUT_AGUARDAR_CONVERSAS_MS = 8000
export const N_ATRASO_PREFETCH_IDLE_MS = 1500
export const N_ATRASO_PREFETCH_POS_CONVERSAS_MS = 3500
export const N_ATRASO_PREFETCH_PADRAO_MS = 2000
